/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactComponent as WhiteLogo } from "src/assets/static/images/whiteLogo.svg";

import { ReactComponent as MapPinLogo } from "src/assets/static/images/map-pin.svg";
import { ReactComponent as MailLogo } from "src/assets/static/images/mail.svg";
import { ReactComponent as PhoneLogo } from "src/assets/static/images/phone.svg";

import { ReactComponent as FaceLogo } from "src/assets/static/images/facebook-logo.svg";
import { ReactComponent as InstaLogo } from "src/assets/static/images/insta-logo.svg";
import { ReactComponent as LinkedinLogo } from "src/assets/static/images/linkedin-logo.svg";
import { Link } from "react-router-dom";
import useFormatById from "src/hooks/utils/useFormatById";
import { useSelector } from "react-redux";

import { ReactComponent as WhiteLogoEng } from "src/assets/static/images/whiteLogo_Eng.svg";
export const imedil_ge = process.env.REACT_APP_MAIN_IMEDIL_LINK;
const Footer = () => {
  const f = useFormatById();
  const lang = useSelector((state) => state.common.lang);
  const darkMode = useSelector((state) => state.common.darkMode);

  return (
    <footer className="page-footer-copyright">
      <div className="container-fluid">
        <footer className="pt-5 pb-md-0">
          <div className="row">
            <div className="col-lg-3 col-md-12 m-auto">
              <Link to={"/"}>
                <ul className="nav flex-column">
                  {lang === "ge" ? (
                    <WhiteLogo className="mx-auto" />
                  ) : (
                    <WhiteLogoEng
                      className="mx-auto"
                      width={"206px"}
                      height={"54px"}
                    />
                  )}
                </ul>
              </Link>
            </div>

            <div className="col-lg-2 col-md-4">
              <ul className="nav flex-column mt-md-4">
                <li className="nav-item mb-2">
                  <Link
                    to={imedil_ge + "about-us/" + lang}
                    className="nav-link p-0"
                    target="_blank"
                  >
                    {f("footer.aboutUs")}
                  </Link>
                </li>
                <li className="nav-item mb-2">
                  <Link
                    to={imedil_ge + "more-about-insurance/" + lang}
                    className="nav-link p-0"
                    target="_blank"
                  >
                    {f("footer.moreAboutInsurance")}
                  </Link>
                </li>
                <li
                  className="nav-item mb-2"
                  style={{ opacity: "0.5", cursor: "unset" }}
                >
                  <a className="nav-link p-0">{f("footer.ourTeam")}</a>
                </li>
                {/* <li className="nav-item mb-2"><Link to={"/"} className="nav-link p-0">{f("footer.ourTeam")}</Link></li> */}
              </ul>
            </div>

            <div className="col-lg-2 col-md-4">
              <ul className="nav flex-column mt-md-4">
                <li className="nav-item mb-2">
                  <Link
                    to={imedil_ge + "vacancy/" + lang}
                    className="nav-link p-0"
                    target="_blank"
                  >
                    {f("footer.career")}
                  </Link>
                </li>
                <li className="nav-item mb-2">
                  <Link
                    to={imedil_ge + "offices/" + lang}
                    className="nav-link p-0"
                    target="_blank"
                  >
                    {f("footer.offices")}
                  </Link>
                </li>
                <li className="nav-item mb-2">
                  <Link
                    to={imedil_ge + "legal-info/" + lang}
                    className="nav-link p-0"
                    target="_blank"
                  >
                    {f("footer.legalInformation")}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4">
              <ul className="nav flex-column mt-md-4">
                <li className="nav-item mb-2">
                  <Link
                    to={imedil_ge + "financial-info/" + lang}
                    className="nav-link p-0"
                    target="_blank"
                  >
                    {f("footer.financialData")}
                  </Link>
                </li>
                <li className="nav-item mb-2">
                  <Link
                    to={imedil_ge + "evaluations/" + lang}
                    className="nav-link p-0"
                    target="_blank"
                  >
                    {f("footer.feedback")}
                  </Link>
                </li>
                <li className="nav-item mb-2">
                  <a
                    href="http://contact.imedil.ge/login"
                    target="_blank"
                    className="nav-link p-0"
                  >
                    {f("footer.onlineCenter")}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-12 text-center mt-3">
              {/* <h5 className='contact-text ps-3 ps-lg-0 me-0 me-xl-5'>{f("footer.contact")} </h5> */}
              <ul className="nav info-class-styles">
                <li
                  className="nav-item mb-2"
                  style={{ cursor: "unset", width: "100%", textAlign: "left" }}
                >
                  <a className="nav-link p-0">
                    <MapPinLogo className="me-2" /> {f("footer.address")}
                  </a>
                </li>
                <li
                  className="nav-item mb-2"
                  style={{ cursor: "unset", width: "100%", textAlign: "left" }}
                >
                  <a className="nav-link p-0" href="tel:(032) 292 22 22">
                    <PhoneLogo className="me-2" /> (032) 292 22 22
                  </a>
                </li>
                <li
                  className="nav-item mb-2"
                  style={{ cursor: "unset", width: "100%", textAlign: "left" }}
                >
                  <a className="nav-link p-0">
                    <MailLogo className="me-2" /> info@imedil.ge
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="text-center mt-5 pb-4 pb-lg-0">
            <span className="footer-logos">
              <a
                href="https://www.facebook.com/imediL"
                target="_blank"
                rel="noreferrer"
              >
                <FaceLogo />
              </a>
            </span>
            <span className="footer-logos">
              <a
                href="https://www.instagram.com/imedi_l/ "
                target="_blank"
                rel="noreferrer"
              >
                <InstaLogo />
              </a>
            </span>
            <span className="footer-logos">
              <a
                href="https://www.linkedin.com/company/imedil/"
                target="_blank"
                rel="noreferrer"
              >
                <LinkedinLogo />
              </a>
            </span>
          </div>
        </footer>
      </div>
    </footer>
  );
};

export default Footer;
